var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.componentClasses},[_c(_setup.Icon,{staticClass:"stk-confidence-icon",attrs:{"icon":_setup.icon,"resize":"3"}}),_vm._v(" "),(!_vm.hideLabel)?_c('span',[_vm._v(_vm._s(_setup.properName))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }